import { APICore } from "./apiCore";

const api = new APICore();

// influencer
function addInfluencerApi(params: { name: string; phone: string; email: string; password: string }) {
  const baseUrl = "/influencer-persons";
  return api.create(`${baseUrl}`, { ...params, role: "influencer" });
}

function updateInfluencerPasswordApi(email: string) {
  const baseUrl = "/update-password-influencer";
  const params = { email };
  return api.updatePatch(`${baseUrl}`, params);
}

function getInfluencerApi() {
  const baseUrl = "/influencer-persons";
  return api.get(`${baseUrl}`, {});
}

function getInfluencerCouponsReportsApi() {
  const baseUrl = "/influencer-reports-coupons";

  return api.get(`${baseUrl}`, {});
}

function getInfluencerCommisionsReportsApi(coupon: string, from?: string, to?: string) {
  const baseUrl = "/influencer-reports-commisions";

  let params: any = {
    coupon,
  };
  if (from) params.from = from;
  if (to) params.to = to;

  return api.get(`${baseUrl}`, params);
}

function updateInfluencerApi(params: { id: string; name: string; phone: string; email: string }) {
  const baseUrl = `/influencer-persons`;
  return api.update(`${baseUrl}`, { ...params, role: "influencer" });
}

function deleteInfluencerApi(id: string) {
  const baseUrl = `/influencer-persons/${id}`;
  return api.delete(`${baseUrl}`);
}

export {
  addInfluencerApi,
  getInfluencerApi,
  updateInfluencerApi,
  deleteInfluencerApi,
  getInfluencerCouponsReportsApi,
  getInfluencerCommisionsReportsApi,
  updateInfluencerPasswordApi
};
